import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { logout } from "features/auth/authSlice";
import { api } from "features/api";
import { apiWithAuth } from "features/auth/auth";

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isAnyOf(
    logout.match,
    apiWithAuth.endpoints.login.matchFulfilled,
    apiWithAuth.endpoints.checkAuth.matchRejected
  ),
  effect: async (action, listenerApi) => {
    if (logout.match(action)) {
      listenerApi.dispatch(api.util.resetApiState());
    }
    localStorage.removeItem("folderMappings");
  },
});

export default listenerMiddleware;
